import { ReactNode } from 'react';
import { cj } from 'src/utils/classNames';

interface AccountListItemProps {
	nameArea: ReactNode;
	infoArea: ReactNode;
	onClick?: () => void;
	isSelected?: boolean;
}

export const AccountListItem = ({
	nameArea,
	infoArea,
	onClick,
	isSelected,
}: AccountListItemProps) => {
	return (
		<div
			className={cj(
				'flex w-full cursor-pointer items-center justify-between px-3.5 py-md hover:bg-button-disabled',
				isSelected ? 'typo-t3 text-text-default' : 'typo-b3 text-text-secondary'
			)}
			onClick={onClick}
		>
			{nameArea}
			{infoArea}
		</div>
	);
};
